import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import useFetchCommunityFeedMemories from 'src/Hooks/Queries/useFetchCommunityFeedMemories';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import { CreateMemoryButton } from '../../CommunityFeed/Memories/CreateMemoryButton';
import { Memory } from '../../CommunityFeed/Memories/Memory';

import styles from './AlbumsCard.module.scss';

/**
 * Right-column card that lists the asset's photo albums (POST_MEMORY feed items)
 * in a grid, with a "create album" tile on top. Replaces the horizontal Memories
 * strip on desktop; the strip stays on mobile inside the chat tab.
 */
const AlbumsCard = () => {
  const { t } = useTranslation();
  const { data: memories } = useFetchCommunityFeedMemories();

  const navigate = useNavigate();
  const assetId = useCurrentAssetId();
  const [memoryToOpenId, setMemoryToOpenId] = useState<string | null>(null);

  const items = memories?.pages.flatMap(page => page.items) ?? [];

  return (
    <div className={styles.box}>
      <span className={styles.title}>{t('community.albumsCard.title', 'Albums de la maison')}</span>
      <span className={styles.subline}>
        {t(
          'community.albumsCard.subline',
          'Une photo par souvenir, un album par événement — la mémoire de la maison, rangée.'
        )}
      </span>

      <div className={styles.grid}>
        <CreateMemoryButton
          onClick={() => navigate(`/asset/${assetId}/memories/new?source=community`)}
        />

        {items.map(memory => {
          const onOpen = () => {
            if (memory.id === memoryToOpenId) {
              setMemoryToOpenId(null);
            }
          };

          return (
            <Memory
              key={memory.id}
              memory={memory}
              shouldOpenModal={memory.id === memoryToOpenId}
              onModalOpened={onOpen}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AlbumsCard;
